import http from "@/settings/apiSettings"

class ForgotPasswordDataService {
    post(identifier: string): Promise<any> {
      return http.clientAuth.post("/auth/ForgotPassword", { email: identifier });
    }

    request(identifier: string): Promise<any> {
  // trimite "Email" cu E mare
  return http.clientAuth.post("/auth/request", { Email: identifier.trim() });
}


    confirm(identifier: string, code: string) {
      const id = (identifier).toString().trim();
    return http.clientAuth.post("/auth/confirm", { identifier: id, code }).then(r => r.data);
}


}

export default new ForgotPasswordDataService();
